import { render, staticRenderFns } from "./select_slot.vue?vue&type=template&id=40f60839"
import script from "./select_slot.vue?vue&type=script&lang=js"
export * from "./select_slot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports